import { DEFAULT_CURRENCY_CODE } from '@angular/core';

import { MerchantStore } from '../../feature/merchant/merchant.store';

export const provideCurrency = () => {
	return {
		provide: DEFAULT_CURRENCY_CODE,
		useFactory: (merchant: InstanceType<typeof MerchantStore>) => merchant.merchant()?.currency(),
		deps: [MerchantStore],
	};
};
